import { render, staticRenderFns } from "./OdpAddPaymentModal.vue?vue&type=template&id=52c12d76"
import script from "./OdpAddPaymentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OdpAddPaymentModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports